import { createSlice } from "@reduxjs/toolkit";
import { AmenitiesSliceState } from "../types";
import { fetchApplicationDetails } from "../../application-section/application-details/redux/services/thunk/DetailsThunk";

const initialState: AmenitiesSliceState = {
  application_category_id: 0,
  category_id: 0,
  property_type_id: 0,
  property_type: "",
  start_chainage_km: "",
  start_chainage_m: "",
  end_chainage_km: "",
  end_chainage_m: "",
  start_chainage: "",
  end_chainage: "",
  chainage: "",
  district: "",
  highway_category: "",
  khasra_number: "",
  taluka: "",
  national_highway_number: "",
  pincode: "",
  plot_length_m: "",
  plot_shape: "",
  plot_width_m: "",
  state: "",
  // terrain_classification: "",
  village: "",
  address_1: "",
  address_2: "",
  plot_area: "",
  authority_name: "",
  authority_id: 0,
  latitude: 0,
  longitude: 0,
  access_id: 0,
  state_code: null,
  highway_side: "",
  // ro_office_location: "",
  // piu_office_location: "",
  ro_id: 0,
  piu_id: 0,
  isFirstSectionCompleted: false,
};

const AmenitiesStateSlice = createSlice({
  name: "AmenitiesSlice",
  initialState,
  reducers: {
    setAmenityField(state: any, action) {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setCoordinatesAccess(state, action) {
      const { latitude, longitude } = action.payload;
      state.latitude = latitude || 0;
      state.longitude = longitude || 0;
    },
    setFirstSectionCompleted(state, action) {
      state.isFirstSectionCompleted = action.payload;
    },
    resetAmenityState(state) {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchApplicationDetails.fulfilled, (state, action) => {
      state.application_category_id = action.payload.application_category_id;
    });
  },
});

export const {
  setAmenityField,
  setCoordinatesAccess,
  setFirstSectionCompleted,
  resetAmenityState,
} = AmenitiesStateSlice.actions;
export default AmenitiesStateSlice.reducer;
